/**
 * 封装的native方法
 * @Author Yang ming
 * @Date 2017/12/14
 *
 * @usage
 * import Native from 'xnpm/@native'
 * let nativeInstance = new Native()
 */
import appInfo from '@xm/appInfo'
// import { orgTypeMap, domainMap } from './methodVersion.js'
import cookie from './cookie'
import utils from './utils'
import mockNative from './mockNative'
import locate from './locate'
import JSBridge from '../lib/bridge'

// 兼容老版本引入CDN的情况
let orgType = cookie.get('orgType')
orgType = orgType ? Number(orgType) : 1
window.AppInfo = appInfo(orgType)

const defaultOptions = {
  isPromise: true,
  orgType,
  local: false
}

export default class Native {
  search = utils.getSearch()
  uid = cookie.get('userId')
  name = cookie.get('username')
  orgId = this.search && this.search.orgId
    ? this.search.orgId
    : cookie.get('orgId')

  // 应用信息
  appInfo = appInfo(orgType)

  // get cookie method
  cookie = cookie.get
  debug = cookie.debug.bind(cookie)

  // native method version
  // methodVersion = domainMap[this.appInfo.domain]

  constructor(options = {}) {
    const mergeOptions = {
      ...defaultOptions,
      ...options
    }
    if (mergeOptions.orgType) {
      // this.setAppInfoByField('orgType', Number(mergeOptions.orgType))
      this.appInfo = appInfo(orgType)
    }
    // else {
    //   console.log('cookie orgType is undefined')
    // }
    this.options = mergeOptions
  }

  /**
   * noop
   */
  setAppInfoByField() {
  }

  // 判断方法是否可用，是否采用mock模式
  native(method, data = {}) {
    if (this.isMethodUseAble(method, data.mock)) {
      return data.mock
        ? mockNative(method, data)
        : JSBridge.nativePromise(method, data)
    } else {
      this.noticeUpdateClient()
      return Promise.reject()
    }
  }

  // 提醒用户升级客户端
  // @params msg {String} 提示语
  noticeUpdateClient(msg = '当前版本不支持该功能，请升级') {
    window.JSBridge.confirm('温馨提示', msg, '立即升级', '取消').then(res => {
      if(res.data === 'ok') {
        location.href = window._ESC_APP_CONFIG && window._ESC_APP_CONFIG.downloadUrl || this.appInfo.data.downUrl
      }
    })
  }

  // 新窗口打开链接
  // @params options {Object} 包含以下参数
  // @params options.url {String} :地址 必填
  // @params options.cookie {Number} 可选选项
  // @params options.noDefaultMenu {Number} 右上角菜单分享菜单按钮
  // @params options.navicolor {String} 导航栏颜色
  openUrl(options) {
    let data = {
      url: '',
      cookie: 1,
      noDefaultMenu: 1,
      // param: '',
      // navicolor: '',
      mock: false
      // needCloseCurrentPage: 1
    }

    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.url = options
    }
    return this.native('openurl', data)
  }

  // 打开应用中心的应用
  // @params options {Object} 包含以下参数
  // @params options.appid {Number} 应用的id 必填
  // @params options {Object} 其他的可选参数
  openApp(options) {
    let data = {}
    if (options instanceof  Object) {
      data = options
    } else {
      data.url = options
    }
    return this.native('openapp', data)
  }

  // ToDo 事项告知 => type 为 4时无效果   待解决
  // 工作台调用
  // @params options {Object} 包含以下参数
  // @params options.type {Number} 工作台类型 必填
  // @params options.id {Number} 具体id 必填
  openOtherPage(options) {
    return this.native('openotherpage', options)
  }

  // 唤醒聊天
  // @params options {Object} 包含以下选项
  // @params options.type {Number} 类型 单人1 群聊2 必填
  // @params options.id {Number} 会话id 必填
  // @params options.name {Number} 会话名称 必填
  chat(options) {
    return this.native('chat', options)
  }


  // 唤醒会议室列表
  // @params options {Object} 参数对象
  // @params options.orgid {Number} 公司id 必填
  // @params options.orgname {Number} 公司名称 必填
  getMeetingPage(options = { orgid: this.orgId }) {
    return this.native('getmeetingpage', options)
  }

  // 会议室管理员列表
  // @params options {Object} 参数对象
  // @params options.orgid {Number} 公司id 必填
  // @params options.orgname {String} 公司名称 必填
  meetingAdminPage(options = { orgid: this.orgId }) {
    return this.native('meetingadminpage', options)
  }

  // 获取客户端版本
  getVersion(mock = false) {
    return new Promise((resolve, reject) => {
      let version
      let appversion = utils.getCookie('appversion')
      if (appversion) {
        version = appversion
        resolve(version)
      } else {
        this.native('getversion', { mock }).then(res=> {
          version =  res.data.version
          // 校验version格式
          // Android_6.8.0
          if (version && !version.includes('_')) {
            version = '_' + version
          }
          resolve(version)
        }).catch((e)=> {
          this.toast('调用客户端version失败')
          reject('None_0.0.0')
        })
      }
    })
  }

  // 获取客户端所有支持的协议和方法
  getAllMethod() {
    return window.JSBridge.native('getallmethod')
  }

  // 判断方法是否被支持
  // @params options {Object|String} 方法名
  // @params mock {Boolean} 是否本地mock
  checkMethod(options) {
    let data = {}
    if (options instanceof Object) {
      data = { ...options }
    } else {
      data.method = options
    }
    return this.native('checkmethod', data)
  }

  // 外部分享
  // @params options {Object|Number} 传递的参数可包含以下选项
  // @params options.type {Number} 1=>微信分享 2=>发送给微信朋友 3=>彩云 4=>QQ好友 必填
  // @params options.title {String} 分享出去的标题
  // @params options.desc {String} 分享描述
  // @params options.link {String} 分享链接
  // @params options.pic {String} 分享时的图片
  outerShare(options) {
    let data = {
      title: '',
      desc: '',
      link: '',
      pic: ''
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.type = options
    }
    return this.native('outershare', data)
  }

  // 分享
  // @params options.title {String} 分享出去的标题
  // @params options.desc {String} 分享描述
  // @params options.link {String} 分享链接
  // @params options.pic {String} 分享时的图片
  share(options) {
    let data = {
      title: '',
      desc: '',
      link: '',
      pic: ''
    }
    data = { ...data, ...options }
    return this.native('share', data)
  }

  // 短信分享
  // @params options {Object|null} 可包含以下可选项
  // @params options.filter {String} 发送对象过滤
  //  ("all":全部,"unactived":未激活，默认全部)
  // @params options.desc {String} 描述内容(为空时取当前窗口的内容)
  msgShare(options = {}) {
    return this.native('msgshare',options)
  }

  // 分享组件
  // @params options {Object} 包含以下参数
  // @params options.type {Number} 具体用的时候找客户端
  // @params options.message {String} 消息内容
  // @params options.extdata {String} 扩展内容(用的时候和type对应)
  sendMsg(options) {
    return this.native('sendmsg',options)
  }

  getOrgNameById(orgId = this.orgId) {
    // let key = this.orgId + '-name'
    // let localName = wsCache.get(key)
    // if (localName) {
    //   // 本地存在
    //   return Promise.resolve(decodeURIComponent(localName))
    // } else {
    // 从客户端取
    return new Promise((resolve, reject)=> {
      this.native('getorglist', { orgId }).then(res=> {
        if (res && res.data.length > 0) {
          // 存在本地 设置失效时间为1d
          // wsCache.set(key, res.data[0].orgName, { exp: 24*3600 })
          resolve(decodeURIComponent(res.data[0].orgName))
        } else {
          this.toast('getOrgNameById，客户端getorglist返回为空')
          reject({ code: 400 })
        }
      })
    })
    // }
  }

  // 选择成员
  // @params options {Object|Number} 当传递对象时，包含以下属性
  // @params options.count {Number} 选择的人数
  // @params options.selectMeType {Number} 对于自己的选择操作，有以下选项
  // 0:默认不选中，可选择，可取消；1: 默认不选中，不可选择；2:默认选中，不可取消；3:默认选中，可选择，可取消
  // @params options.orgid {Number} 企业id
  // @params options.orgName {String} 企业名称
  // @params options.type {Array|Number} 获得的群类型,包含以下选项
  // 1:组织机构 2:群 3:手机通讯录 4:名片夹 5:我的好友 6:常用联系人 7:外部共享联系人
  // @params options.excludedtype {Array|Number}
  // 1:排除未激活 2:排除已激活 3:排除无手机号 4:排除无邮箱 5:排除管理员 6:排除老板
  // @params options.selected {Array} 默认选中人的数组
  // @params options.department {Array} 从哪些部门选中
  selectMembers(options) {
    return this.getOrgNameById().then(orgName=> {
      let data = {
        count: 5,
        selectMeType: 0,
        orgid: this.orgId,
        orgName,
        type: 1,
        excludedtype: 1,
        selected: [],
        department: []
      }
      if (options instanceof Object) {
        if (options.type && Array.isArray(options.type)) {
          options.type = utils.getBinarySum(options.type)
        }
        if (options.excludedtype && Array.isArray(options.excludedtype)) {
          options.excludedtype = utils.getBinarySum(options.excludedtype)
        }
        data = { ...data, ...options }
      } else if (typeof options === 'number') {
        data.count = options
      }
      return this.native('selectmembers', data)
    })
  }

  // 选择部门
  // @params options {Object|Number} 包含以下选项
  // @params options.count {Number} 选择的部门数
  // @params options.orgid {Number} 企业id
  // @params options.selected {Array} 已选择部门的数组
  selectDepartments(options) {
    let data = {
      count: 5,
      orgid: this.orgId,
      selected: []
    }
    if (options instanceof Object) {
      data = { ...data, ...options}
    } else if (typeof options === 'number') {
      data.count = options
    }
    return this.native('selectdepartments', data)
  }

  // 获取企业信息
  // @params orgid {Number} 企业id 选填
  getOrgList(orgid = this.orgId) {
    let data = {}
    if (orgid) {
      data.orgid = orgid
    }
    return this.native('getorglist', data)
  }

  // 后端返回 { code:200 } 暂不明白意思
  // @params orgid {Number} 企业id 选填
  getOrgAdminList(orgid = this.orgId) {
    let data = {}
    if (orgid) {
      data.orgid = orgid
    }
    return this.native('getorgadminlist', data)
  }

  // 判断用户是否为企业的管理员
  // @params options {Object} 包含以下可选项
  // @params options.uid {Number} 用户id
  // @params options.orgid {Number} 企业id
  isOrgAdmin(options) {
    let data = {
      uid: this.uid,
      orgid: this.orgId
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.uid = options
    }
    return new Promise((resolve, reject) => {
      this.getOrgAdminList(data.orgid).then(res => {
        if (res.data && res.data.length) {
          res.data.map((item, index) => {
            if (item.uid === data.uid) {
              resolve(true)
            }
          })
        }
        resolve(false)
      })
    })
  }

  // 获取定位信息
  locate(options) {
    return locate.call(this, options)
  }

  // H5打点到友盟
  // @params options {Object|String} 包含以下选项
  // @params eventId {String} 统计事件ID(在友盟中定义)
  // @params param {String} 在友盟里的一个跟踪参数
  // 返回service-1 对应数组[移动,联通,电信]
  pageStat (options) {
    let data = {}
    if (options instanceof Object) {
      data = options
    } else {
      data.eventId = options
    }
    return this.native('pagestat', data)
  }

  // 获取用户手机类型
  getOperator(mock = false) {
    return this.native('getoperator', { mock: false })
  }

  // 客户端右上角自定义菜单
  // @params options {Array} 包含以下属性
  // @params options.name {String} 菜单名
  // @params options.icon {String} 菜单名前图标
  // @params options.action {String} 菜单执行动作
  // @params options.unreadCount {Number} 菜单红点（默认0不显示红点，大于0显示红点）
  menu(options) {
    let data = {
      name: '',
      icon: '',
      action: '',
      unreadCount: 0,
      mock: false
    }
    if (Array.isArray(options)) {
      data = options.map(item=> {
        return { ...data, ...item }
      })
    } else {
      this.toast('menu options is a array')
    }
    return this.native('menu', data)
  }

  // { '完成': ()=> {} }
  menuCallJs(name, fn) {
    let fnName
    let menuData = []

    if (typeof name === 'object') {
      menuData = Object.keys(name).map((key, i)=> {
        fnName = utils.genderCallbackToken(i)
        this.defineCallback(fnName, name[key])
        return {
          name: key,
          action: `native://calljs?callback=${fnName}`
        }
      })
    } else if (typeof name === 'string' && typeof fn === 'function') {
      fnName = utils.genderCallbackToken()
      this.defineCallback(fnName, fn)
      menuData.push({
        name,
        action: `native://calljs?callback=${fnName}`
      })
    }
    this.menu(menuData)
  }

  // 刷新当前页，不打开新的webview
  // @params options {Object|String} 当前页url
  refresh(options) {
    let data = {}
    if (options instanceof Object) {
      data = options
    } else {
      data.name = options
    }
    this.native('locate', data)
  }

  // 查看我的计步器
  // @params options {Object|Number} 包含以下选项
  // @params pageIndex {Number} 应跳转到的界面类型 可选一下类型
  // 0:计步器首页,1.0:今日榜单部门排行,1.1:今日榜单公司排行,2:个人信息
  // @params leaderboardTimestamp {Number} Unix时间戳，默认为今天
  pedometer(options) {
    let data = {}
    if (options instanceof  Object) {
      if (typeof options.leaderboardTimestamp === 'string') {
        options.leaderboardTimestamp = new Date(options.leaderboardTimestamp).getTime()*1000
      }
      data = options
    } else {
      data.pageIndex = options
    }
    return this.native('pedometer', data)
  }

  // 一键激活
  // @params options {Object|Number} 包含以下属性
  // @params options.orgId {Number} 企业id
  // @params options.deptIds {Array|Number} 部门id数组或部门id
  activeAll(options) {
    let data = {
      orgId: this.orgId
    }
    if (options instanceof Object) {
      if (typeof options.deptIds === 'number') {
        data.deptIds = [options.deptIds]
      } else if (Array.isArray(options.deptIds)) {
        data.deptIds = options.deptIds
      }
      data = { ...data, ...options }
    } else {
      data.orgId = options
    }
    return this.native('activeall', data)
  }

  // 添加管理员
  // @params options {Object|Number}
  // @params options.orgId {Number} 企业id
  // @params options.type {Number} 管理员类型
  // 1=>管理员 2=>老板
  addAdmin(options) {
    let data = {
      orgId: this.orgId
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.orgId = options
    }
    return this.native('addadmin', data)
  }

  // 判断是否是wifi环境
  isWifi() {
    return this.native('iswifi')
  }

  // 工作轨迹
  // @params options {Object|Number}
  // @params options.type {Number} 应跳转到的界面类型，不同类型传不同的参数
  // 0=>工作轨迹首页
  // @params options.orgId {Number} 企业id
  // 1=>详情页
  // @params options.contailId {Number} 详情id
  workingTrack(options) {
    let data = {
      orgId: this.orgId
    }
    if (options instanceof Object) {
      data = { ...data, ...options}
    } else {
      data.type = options
    }
    return this.native('workingtrack', data)
  }

  // ToDo 无反应
  // 修改用户信息
  // @params options {Objecct
  // @params options.uid {Number} 用户id
  // @params options.orgid {Number} 企业id
  // @params options.name {String} 姓名
  // @params options.mobile {String} 手机1
  // @params options.title {String} 职位
  // @params options.email {String} 邮箱
  // @params options.workPhone {String} 固话1
  // @params options.shotNum {String} 分号1
  // @params options.workPhone2 {String} 固话2
  // @params options.shotNum2 {String} 分机号2
  // @params options.homePhone {String} 手机2
  // @params options.fax {String} 传真
  // @params options.departmentId {Number} 部门
  // @params options.newDeptId {Number} 部门
  updateUser(options) {
    let data = {
      uid: this.uid,
      orgid: this.orgId,
      name: '',
      mobile: '',
      title: '',
      email: '',
      workPhone: '',
      shotNum: '',
      workPhone1: '',
      shotNum1: '',
      workPhone2: '',
      shotNum2: '',
      homePhone: '',
      fax: '',
      departmentId: 0,
      newDeptId: 0
    }
    data = { ...data, ...options }
    return this.native('updateuserinfo', data)
  }

  // ToDo 没有反应
  // 修改企业信息
  // @params options{Object|Number|String}
  // @params options.orgid {Number} 企业id
  // @params options.orgname {String} 企业名称
  updateOrgname(options) {
    let data = {
      orgid: this.orgId,
      orgName: ''
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else if (typeof options === 'string') {
      data.orgName = options
    } else {
      data.orgid = options
    }
    return this.native('updateorgname', data)
  }

  // 添加考勤助手
  // @params id {Number} id
  addIbeacon(id) {
    return this.native('addibeacon', { id: id })
  }

  // 获取设备唯一标识
  getMachineId() {
    return this.native('getidentification')
  }

  // ToDo 无反应
  // 获取当前可用的wifi列表
  availableWifiList() {
    return this.native('availablewifilist')
  }

  // 获取当前连接的wifi信息
  currentWifi() {
    return this.native('currentwifi')
  }

  // 文件上传
  // @params url {String} 上传的地址
  saveFile(url) {
    return this.native('saveFile', { url: url })
  }

  // ToDo 无反应
  // 插入日程
  // @params options {Object} 必需为对象
  // @params options.content {String} 内容
  // @params options.starttime {Number} 开始时间
  // @params options.endtime {Number} 结束时间
  // @params options.alerttime {Number} 提醒时间
  // @params options.url {String} 日程详情链接
  // @params options.note {String} 备注
  systemEvent(options) {
    let tomorrow = utils.getTomorrowTimeStamp()
    let now = new Date().getTime()*1000
    let data = {
      content: '',
      stattime: now,
      endtime: tomorrow,
      alerttime: (tomorrow + now)/2,
      url: '',
      note: ''
    }
    data = { ...data, ...options }
    return this.native('systemevent', data)
  }

  // ToDo 根据cookie设置默认服务端上传地址
  // 录制语音
  // @params url {String} 语音上传的服务端地址url
  audioRecord(url = '') {
    return this.native('audioRecord', { url: url })
  }

  // 录制视频
  // @params url {String} 视频上传的地址url
  videoRecord(url = '') {
    return this.native('videoRecord', { url: url })
  }

  // 解散团队
  // @params orgid {Number} 企业id
  dissolveTeam(orgid = this.orgId) {
    return this.native('dissolveteam', { orgid: orgid })
  }

  // 打开pdf
  // @params options {Object|String}
  // @params options.url {String} pdf文件的url地址
  // @params options.name {String} 文件名
  // @params options.buttons {Array} pdf展示页面底部按钮，数组，每项格式如下
  // {name: '', action: ''}
  openPdf(options) {
    let data = {
      url: '',
      name: '',
      buttons: []
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.url = options
    }
    return this.native('openpdf', data)
  }

  // ToDo 无反应
  // 消息红点
  // @params options {Object}
  // @params options.orgId {Number} 企业id
  // @params options.appId {Number} 应用id
  // @params options.unreadCount {Number} 为0的时候清掉红点，为其他值显示红点
  msgRedDot(options) {
    let data = {
      orgId: this.orgId
    }
    data= { ...data, ...options }
    return this.native('msgRedDot', options)
  }

  // ToDo 无反应
  // 让客户端更新工作tab上审批，工作报告，签到的显示数量
  // @params iconId {Number} 对应入口的数据id
  // 38:未读公告;39:出勤人数;40:迟到次数;41:我的审批;42:待我审批;43:今日步数;44:未激活人数;45:未读工作报告
  callClientUpdate(iconId) {
    let data = {
      orgId: this.orgId,
      iconId: iconId
    }
    return this.native('callclientupdate', data)
  }

  // 收起客户端键盘
  hideKeyboard() {
    this.native('hidekeyboard')
  }

  // 创建团队
  createTeam() {
    this.native('createteam')
  }

  // 打开更多应用
  openCommonTools() {
    this.native('opencommontools')
  }

  // 选择文件
  // @params options {Object}
  // @params options.count {Number} 选择数量(0表示不限个数)
  // @params options.type {Number} 类型（1:照片 2:云盘 4:手机文件(仅限安卓) ）
  selectFile(options) {
    return this.native('selectfile', options)
  }

  // 打开邀请页面
  openInvite() {
    return this.native('openinvite')
  }

  // 选择地区
  // @params selected {Number} 最后一级的code
  selectCity(selected) {
    return this.native('selectcity', { selected })
  }

  // 选择行业
  // @params selectindustry {Number} 最后一级的code
  selectInDustry(selected) {
    return this.native('selectindustry', { selected })
  }

  // 调用客户端个人详情面板
  personDetail(options) {
    let data = {
      uid: this.uid,
      name: ''
    }
    if (options instanceof Object) {
      data = { ...data, ...options}
    } else {
      data.uid = options
    }
    return this.native('persondetail', data)
  }

  // 生成二维码字符串
  cameraScan() {
    return this.native('camerascan')
  }

  // 向JSBridge中添加回调函数
  defineCallback(name, fn) {
    if (typeof name === 'string') {
      window.JSBridge._callback[name] = fn
    } else {
      Object.keys(name).map(key => {
        window.JSBridge._callback[key] = name[key]
      })
    }
  }

  // 客户端调用js方法
  // callJs() {
  // 	return this.native('calljs')
  // }

  callParentJs(data, callback) {
    if (!this.isMethodUseAble('callparentjs')) {
      this.noticeUpdateClient()
      return
    }

    let callUrl = 'native://callparentjs'
    callUrl += `?data=${encodeURIComponent(JSON.stringify(data))}`
    callUrl += `&callback=${callback}`

    // eslint-disable-next-line
    window.JSBridge._postToNative(callUrl)
    window.JSBridge.native('close')
  }

  // 呼起客户端个人详情编辑面板
  editUserDetail() {
    // let data =
    return this.native('edituserdetail')
  }

  noMenu() {
    window.JSBridge.noMenu(true)
  }

  toast(str) {
    console.log(str)
    window.JSBridge.toast(str)
  }

  // alert提示框
  alert(title = '', msg = '') {
    return this.native('alert', {
      msg: msg,
      title: title
    })
  }

  // confirm确认框
  confirm(options) {
    let data = {
      title: '',
      msg: '',
      ok: '确定',
      cancel: '取消'
    }
    if (typeof options === 'string') {
      data.msg = options
    } else {
      data = { ...data, ...options }
    }
    return new Promise((resolve, reject)=> {
      this.native('confirm', data).then(res=> {
        if (res.data === 'ok') {
          resolve()
        } else if (res.data === 'cancel') {
          reject()
        }
      })
    })
  }

  // prompt 输入提示框
  // @params options {Object}
  // @params title {String} 标题
  // @params msg {String} 提示信息
  // @params placeholder 文本框提示文本
  // @params textLength 输入长度
  prompt(options) {
    let data = {
      title: '',
      msg: '',
      placeholder: '',
      textLength: -1,
      confirmText: '确定',
      cancelText: '取消'
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.title = options
    }

    return this.native(
      this.isMethodUseAble('multilineprompt') ? 'multilineprompt' : 'prompt',
      data
    )
  }

  // actionsheet 操作多选
  // @params options {Object|String}
  // @params options.title {String} 标题
  // @params options.list {Array} 提示信息
  actionSheet(options) {
    let data = {
      title: '',
      list: []
    }
    if (options instanceof Object) {
      if (typeof options.list === 'string') {
        data.list.push({
          text: '',
          desc: '',
          value: ''
        })
      }
      if (Array.isArray(options.list)) {
        data.list = [ ...options.list ]
      }
    } else {
      data.list.push({
        text: '',
        desc: '',
        value: ''
      })
    }
    return this.native('actionSheet', data)
  }

  // 模态框
  // @params options {Object|String}
  // @params options.title {String} 标题
  // @params options.msg {String} 内容
  // @params options.img {String} 图片地址
  // @params options.link {String} 点击了解更多跳转地址
  modal(options) {
    let data = {
      title: '',
      msg: '',
      img: '',
      link: ''
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.title = options
    }
    return this.native('modal', data)
  }

  // 选择图片
  // @params max {Number} 最多选择图片数
  selectPic(max = 5) {
    return this.native('selectpic', { max: max })
  }

  // 选择日期
  // @params options {Object|Number}
  // @params options.type {Number} 区分选择时间的类型
  // 1=>默认现有的类型，根据format返回不同的值 2=>选择一天中的上午下午
  // @params options.customData {Array} type=2时有效，例如customData=['上午', '下午']
  // @params options.defaultValue {Number} 默认的时间
  // @params options.defaultCustomValue {String} type=2时有效，例如defaultCustomValue='上午'
  // @params options.format {String} 返回格式
  selectDate(options) {
    let data = {
      type: 1,
      customData: ['上午', '下午'],
      defaultValue: new Date().getTime(),
      defaultCustomValue: '上午',
      format: 'yyyy-MM-dd HH:mm'
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.type = options
    }
    return this.native('selectdate', data)
  }
  // 只能选时间段，返回时间戳
  // @params options {Object} 参数对象
  // @return Promise
  selectPeriodDate(options) {
    return new Promise((resolve, reject) => {
      let data = {
        type: 2,
        customData: ['上午', '下午'],
        customDataTime: ['08:00', '18:00'],
        defaultValue: new Date('2018-01-25 08:00').getTime(),
        defaultCustomValue: '上午'
      }
      if (options instanceof Object) {
        data = { ...data, ...options }
      } else if (options) {
        this.toast('参数错误')
        return
      }

      this.native('selectdate', data).then(res => {
        if (data.type === 1) {
          resolve({
            code: 200,
            data: new Date(res.data).getTime()
          })
        } else {
          let period = res.data.slice(res.data.length - 2),
              idx = data.customData.indexOf(period),
              timeStr = res.data.replace(period, data.customDataTime[idx])
              resolve({
                code: 200,
                data: new Date(timeStr).getTime()
              })
        }
      })
    })
  }



  // 选取组件
  picker(options) {
    let data = {
      title: '',
      list: []
    }
    if (options instanceof Object) {
      if (Array.isArray(options.list)) {
        data.list = [ ...options.list ]
      } else {
        data.list.push({
          text: '',
          value: ''
        })
      }
    }
    return this.native('picker', data)
  }

  // 选择企业
  // selectCorp() {
  // 	return this.native('selectcorp')
  // }

  // 唤起拍照
  // Todo 拍照后无反应
  photo() {
    return this.native('photo')
  }

  // 跳转到我的好友
  findFriend() {
    return this.native('findfriend')
  }

  // 新建日程
  // @params options {Object}
  // @params options.content {String} 内容 必填
  // @params options.time {Number} 日程时间 必填
  // @params options.remindtime {Number} 提醒时间(默认0，老版本)
  // @params options.remindtype {Number} 提醒方式
  // @params options.priority {Number} 优先级
  schedule(options) {
    let data = {
      content: '',
      time: new Date().getTime(),
      remindtime: utils.getTomorrowTimeStamp(),
      remindtype: 1,
      priority: 0
    }
    if (options instanceof Object) {
      data = { ...data, ...options}
    } else {
      data.content = options
    }
    return this.native('schedule', data)
  }

  // 跳转至联系管理员页面
  // @params options {Object|Number}
  // @params options.orgid {Number} 企业id
  // @params options.departid {Number} 部门id
  // orgid和departid都没有不发生跳转；只有orgid跳转到联系【企业】管理员页面；都有跳转到联系【部门】管理员页面
  openContractManager(options) {
    let data = {
      orgid: this.orgId
    }
    if (options instanceof Object) {
      data = { ...data, ...options }
    } else {
      data.orgid = options
    }
    return this.native('opencontractmanager', data)
  }

  // 发起聊天
  launchChat() {
    return this.native('launchchat')
  }

  // 关闭webview
  close() {
    return this.native('close')
  }

  // 关闭自动考勤弹框
  closeSignAlert() {
    return this.native('losesignalert')
  }

  // 预览图片
  // @params options {Object}
  // @params position {Number} 打开时展示第几张图片
  // @params urls {Array} 预览的图片链接数组
  previewImages(options) {
    let data = {
      position: 0,
      urls: []
    }
    data = { ...data, ...options }
    return this.native('previewimages', data)
  }

  // ToDo datatype 为1时无反应
  // 自定义级联下拉
  // @params options {Object}
  // @params dialogTitle {String} 窗口标题
  // @params level {Number} 级联的层级 展示几级
  // @params datatype {Number} 数据是否有级联关系，0有级联，1没有级联；默认0
  // @params selected {Array} 已选择的值
  // @params data {Number} datatype===0 时的数据源
  // @params idata {Number} datatype===1 时的数据源
  customDataSelect(options) {
    let data = {
      dialogTitle: '',
      level: 0,
      datatype: 0,
      selected: [],
      data: [],
      idata: []
    }
    data = { ...data, ...options }
    return this.native('customdataselect', data)
  }

  // 校验native方法是否可用
  // @param method 方法名
  // @param mock 是否为本地mock数据
  // @returns {boolean}
  isMethodUseAble(method, mock = false) {
    // let version = this.cookie('appversion')
    // let methodVersion = this.methodVersion
    //
    // if (mock) {
    //   console.log(`mock native method: ${method}`)
    //   return true
    // }
    //
    // if (this.options.local) {
    //   version = 'local_100.0.0'
    //   console.log('mock local version: local_100.0.0')
    // } else if (!version || !/_/.test(version)) {
    //   console.warn('cookie version is not found')
    //   return false
    // }
    //
    // if (methodVersion && Object.keys(methodVersion).includes(method)) {
    //   return this.compareVersion(version, methodVersion[method])
    // }
    return true
  }

  compareVersion(localVersion, newVersion) {
    if (!localVersion) {
      return false
    }
    localVersion = localVersion.split('_')[1].split('.').map(x => Number(x))
    newVersion = newVersion.split('.').map(x => Number(x))

    for (let i = 0; i < localVersion.length; i++) {
      if (localVersion[i] < newVersion[i]) {
        return false
      }
    }
    return true
  }

  commonCatchSchema(method, data, nativeResult) {
    if (nativeResult) {
      console.log(nativeResult)
    }
    this.toast(`${method} is call error by client`)
  }
}

